import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/atlasContent';
const stats = [{
  value: '2.847',
  label: 'Urban Farmers nutzen das System'
}, {
  value: '4,9/5',
  label: 'Sterne Bewertung'
}, {
  value: '92 %',
  label: 'sagen: „Das sollte Standardausrüstung sein"'
}];
function Stars() {
  return <div className="flex gap-1" role="img" aria-label="5 von 5 Sternen" data-id="element-90" data-mp="3bvg8rvhmql9d">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-emerald text-emerald" aria-hidden="true" data-id="element-91" data-mp="3gy320f5vhsx" data-mpi={i} />)}
    </div>;
}
export function SocialProof() {
  return <section className="border-b border-line bg-canvas py-20 lg:py-28" style={{
    paddingTop: "15px",
    paddingBottom: "15px"
  }} data-id="element-92" data-mp="3puz9w4c0wwc6">
      <div className="mx-auto max-w-7xl px-6" data-id="element-93" data-mp="3ury6ctj5tfdj">
        <h2 className="max-w-3xl font-serif text-3xl font-semibold leading-tight tracking-tight text-forest sm:text-4xl" style={{
        fontSize: "24px"
      }} data-id="element-94" data-mp="mdz97okgbnyg">
          Warum Urban Farmer in Deutschland, Österreich und der Schweiz das vertrauen
        </h2>

        <ul className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3" data-id="element-95" data-mp="1u7qmu22g2p7c">
          {testimonials.map(t => <li key={t.name} className="flex h-full flex-col rounded-xl border border-line bg-surface p-7 shadow-md shadow-forest/10" style={{
          paddingTop: "0px",
          paddingBottom: "0px",
          borderColor: "#40916C"
        }} data-id="element-96" data-mp="1pcl1b4cyfcjs">
              <Stars data-id="element-97" data-mp="1z6uyczcucz0u" />
              <blockquote className="mt-5 flex-1 text-[15px] leading-relaxed text-forest" data-id="element-98" data-mp="2d02mgh1prcds">„{t.quote}"</blockquote>
              <footer className="mt-auto flex items-center gap-3 border-t border-line pt-5" data-id="element-99" data-mp="281rekbuzbby7">
                <img src={t.avatar} alt={`Porträt von ${t.name}`} className="h-11 w-11 shrink-0 rounded-full object-cover" data-id="element-100" data-mp="2mz1zebtihu6l" />
                <div className="min-w-0" data-id="element-101" data-mp="2i0gu3xzekkba">
                  <p className="text-sm font-semibold text-forest" data-id="element-102" data-mp="2hxkzojmrkdrl">
                    {t.name} <span className="font-normal text-emerald" data-id="element-103" data-mp="skr9s153evzr">· {t.location}</span>
                  </p>
                  <p className="mt-0.5 truncate text-xs text-prose" data-id="element-104" data-mp="nn8wjyk1luly">{t.role}</p>
                </div>
              </footer>
            </li>)}
        </ul>

        <dl className="mt-12 grid grid-cols-1 divide-y divide-line rounded-xl border border-line bg-surface shadow-md shadow-forest/10 sm:grid-cols-3 sm:divide-x sm:divide-y-0" data-id="element-105" data-mp="1hadeoa0fwvo0">
          {stats.map(s => <div key={s.label} className="px-6 py-7" style={{
          paddingTop: "10px",
          paddingBottom: "10px"
        }} data-id="element-106" data-mp="1r9ul4tnindl1">
              <dt className="sr-only" data-id="element-107" data-mp="1w7wc00r6oh72">{s.label}</dt>
              <dd data-id="element-108" data-mp="209reh8kup0mf">
                <span className="block font-mono text-3xl font-semibold text-emerald" data-id="element-109" data-mp="2097xbu30yg9g">{s.value}</span>
                <span className="mt-2 block text-sm text-prose" data-id="element-110" data-mp="251r7si6f0va1">{s.label}</span>
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}